export default __webpack_public_path__ + "../images/category-catalog-7.png";